import { isPlatformBrowser} from '@angular/common';
import {Inject, Injectable, PLATFORM_ID} from "@angular/core";

declare global {
  interface Window {
    dataLayer: any;
  }
}

@Injectable({
  providedIn: 'root',
})
export class DatalayerService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
  }

  sendDatalayer(event: string, opitions?: any): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    window.dataLayer.push({
      event: event,
      ...opitions
    });
  }
}
